import classNames from 'classnames'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Loader from '../Loader/Loader'
import classes, { stylesheet } from './PageLoader.module.scss'
import { useStyles } from '@vp/ubik-context'

const PageLoader: FC<{
  className?: string
  spinnerClassName?: string
  backdropStyle?: 'default' | 'black' | 'white' | 'blur'
  text?: string
  showText?: boolean
  size?: 'standard' | 'super' | 'mini' | 'tiny'
  overlay?: boolean
  layout?: 'vertical' | 'horizontal'
}> = ({ className, spinnerClassName, backdropStyle, text, showText, size, overlay, layout }) => {
  useStyles(stylesheet)

  let bgClass = ''

  switch (backdropStyle) {
    case 'black':
      bgClass = classes.blackBackdrop
      break
    case 'white':
      bgClass = classes.whiteBackdrop
      break
    case 'blur':
      bgClass = classes.blurBackdrop
      break
  }
  const { t } = useTranslation()

  return (
    <div className={classNames(className, classes.page, bgClass)}>
      <Loader
        loaderWrapperClassName={classes.fullPageLoader}
        text={(text && text) || t('globalVariables.defaultLoaderText')}
        showText={(showText && showText) || false}
        size={(size && size) || 'standard'}
        layout={(layout && layout) || 'vertical'}
        overlay={(overlay && overlay) || false}
        className={spinnerClassName}
      />
    </div>
  )
}

export default PageLoader
